import { Box, color, Text } from '@bfa/common-ui';
import React from 'react';
import styled from 'styled-components';

const StyledText = styled(Text)`
  & > a {
    color: ${color('gbDarkest')};
  }
`;

const Disclaimers = ({
  disclaimers,
}: {
  disclaimers?: (string | null | undefined)[] | null;
}) => {
  if (!disclaimers) return null;

  const dislclaimerArray = disclaimers.filter(
    (disclaimer) => disclaimer !== null && disclaimer !== undefined
  ) as string[];

  if (dislclaimerArray.length === 0) return null;

  return (
    <Box marginTop="2rem">
      {dislclaimerArray.map((disclaimer: string, index) => {
        return (
          <StyledText
            key={+index}
            as="p"
            fontSize="1.2rem"
            color="grayMedium"
            dangerouslySetInnerHTML={{ __html: disclaimer }}
          />
        );
      })}
    </Box>
  );
};

export default Disclaimers;
